export default {
  welcomeEvent: '¡Let´s create a great event together!',
  noEvent: 'No tienes eventos activos',
  createEvent: 'Create event',
  uniqueEvent: 'Unique',
  multipleEvent: 'Multiple',
  physicalEventLocation: 'Physical',
  digitalEventLocation: 'Digital',
  createCampaingLink: 'Create campaign',
  uniqueTitle: '¿The event you are going to create is unique or will be repeated several times?',
  infoTitle: 'Information',
  scheduleTitle: 'Agenda',
  ticketsTitle: 'Tickets',
  paymentTitle: 'Payment and promotion',
  lastTitle: 'Last touches',
  titleMagic: 'Let´s create a magical event',
  checkSchedule: 'Let me check my schedule',
  ticketsEvents: 'Tickets, tickets, tickets!!!',
  nameEvent: '¿What is the name of the event?',
  describeEvent: 'Describe your event',
  categoryTitle: 'Categories',
  selectCategory: 'Select the category of the event',
  seeEvent: 'Select who can see the event',
  publicEventTitle: 'Public',
  privateEventTitle: 'Invited only',
  privateEventSubtitle: '*Anyone can view and search public events',
  whereEvent: '¿Where will your event be held??',
  addressEvent: 'Address',
  infoExtraEvent: 'Extra information',
  buildingEvent: 'Edification',
  continueBtn: 'Continue',
  linkEvent: 'Event link',
  selectDate: 'Select the date of your event',
  dateStart: 'Date',
  dateEnd: 'End date',
  timeTitleStart: 'Start hour',
  timeTitleFinish: 'Finish hour',
  nameTicket: 'Ticket name',
  exampleTicket: 'Example: Plantinum, VIP',
  quantityTicket: 'Quantity',
  typeTicket: 'Type of ticket',
  priceUnit: 'Price x unit',
  numberSits: '¿Numbered stall?',
  discountTicket: 'Enable discount coupons',
  discountPorcentage: '% discount',
  assignPromoter: 'Assign ticket to a promoter',
  createPromoter: 'Create a promoter',
  responsablePromoter: 'Responsable promoter',
  ticketQR: 'Digital (QR)',
  ticketPhysical: 'Physical ticket',
  addPromoter: 'add promoter',
  assignLogistic: 'Assign logistic personal',
  createLogistic: 'Create logistic user',
  addLogistic: 'Add logistic',
  duplicateItem: 'Duplicate',
  eraseItem: 'Delete',
  enablePayment: 'Enable payment method',
  addPaymentMethod: 'Add payment method',
  promotionEvent: 'Promotion',
  micrositeTitle: 'Url of event',
  additionalMsg: 'Additional message',
  messageEmail: 'This message will appear in the ticket confirmation email and on the ticket itself',
  coverImgEvent: 'Cover image',
  uploadImagesEvent: 'Upload up to 6 images to promote your event',
  resumenBtn: 'Resume',
  psePayment: 'PSE payments',
  creditPayment: 'Credit card payments',
  taxesEvent: 'Taxes',
  lastTitleEvent: 'See you soon!',
  howToFindEvent: 'How would you like to be found?',
  associateSocialMedia: 'Link you social media',
  addSocialMedia: 'Add a social network',
  addAnotherTime: 'Add another time for the event',
  imagesTitle: 'Almost there',
  eventCover: 'Event cover',
  ticketSaleDateTitle: 'Select the date and name a stage for the ticket sale',
  stageName: 'Stage name',
  addAnotherStage: 'Add a stage',
  ticketType: 'Ticket type',
  freeTickets: 'Free',
  paidTickets: 'Paid',
  ticketSaleUsers: 'Select the maximum number of tickets that a user can buy',
  numeric: 'Numeric',
  alfabetic: 'Alphanumeric',
  paid: 'Paid',
  free: 'Free',
  responsibleLogistic: 'Responsable logistic',
  activeEvent: 'Published',
  inactiveEvent: 'Inactive',
  ds: 'Saved',
  soldTickets: 'Sold tickets',
  checkedIn: 'Checked',
  businessFee: 'Bussiness fee',
  totalProfit: 'Total Profit',
  search: 'Search',
  resumeEvent: 'Event summary',
  assistantId: 'Assistant ID',
  document: 'Document',
  statusCode: 'Status transaction',
  ticketsFee1: 'Absorb ticket service:',
  ticketsFee2: 'Ticketing fees are deducted from revenue per ticket.',
  buyerPay: 'The buyer will pay:',
  detailsPaymentTax: 'View details',
  costBuyer: 'Cost to buyer',
  costTicket: 'Ticket price',
  serviceTicket: 'Service fee',
  yourPayout: 'Your payout',
  payoutTicket: 'Price per ticket',
  btnDetailsPayout: 'Done!',
  copyLink: 'Copy',
  categoryRsmEvent: 'Event category:',
  seeEventRsm: 'You can find it:',
  typeEventRsm: 'It will be an event:',
  placeEventRsm: 'Place configuration:',
  maxTicketsRsm: 'NO. Max tickets / user:',
  dateEventRsm: 'Date event:',
  stagesRsm1: 'You have ',
  stagesRsm2: ' configured stages:',
  stageAvailableTicketsRsm: ' tickets availables',
  stageInitRsm: 'Starts at',
  stageEndRsm: 'until',
  linkEventRsm: 'Link of event:',
  additionalMsgRsm: 'The additional message that you configured to be sent in the purchase confirmation email is:',
  noteDateStage: 'From this date will start the sale for your tickets',
  btnTicketPreview: 'See ticket',
  launchEvent: 'Launch event',
  saveChanges: 'Save changes',
  pulp: 'PULP code',
  pulpPlaceholder: 'Paste your PULP code from your event',
  nameEventTable: 'Event',
  totalTicketsTable: 'Total tickets',
  ticketsAvailableTable: 'Available tickets',
  createdAtTable: 'Creation date',
  persons: 'persons',
  allEvents: 'All events',
  titleEvents: 'Events',
  pages: ' results',
  noResults: 'No results',
  associateWebSites: 'Link your websites',
  addWebSite: 'Add a website',
  addPlace: 'Add place',
  examplePlace: 'Example: stadium, museum',
  urlCopied: 'Url copied',
  repeatedEvent: 'Event created before with the same name',
  savedEvent: 'Saved event',
  saveEvent: 'Save event',
  downloadTicket: 'Download ticket',
  stage: 'Stage',
  editImages: 'Edit the images of the event',
  editEvent: 'Edit',
  payEvent: 'Payment',
  assistanceList: 'List of assistants',
  totalTickets: '# tickets',
  totalTicketsLarger: 'Ticket amount is larger that the ticket amount by stages',
  totalTicketsSmaller: 'Ticket amount is smaller that the ticket amount by stages',
  totalTicketAmount: 'Total ticket amount',
  mustSelectTicketType: 'Must select a ticket type',
  websites: 'Websites',
  ticketsEdited: 'Ticket edited',
  didntFindAddress: 'Sorry, we couldnt find the address'
}
